import { DirectoryAttributeDirectionConsts, DirectoryTypeKeys } from 'client/util/Constants';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import createDirectoryCollection from 'client/store/modules/models/createDirectoryCollection';

const exportAttr = DirectoryAttributeDirectionConsts.export.value;
const excludeAttr = DirectoryAttributeDirectionConsts.exclude.value;

/**
 * The frozen attributes are always exported to Google and cannot be disabled.
 * All other attributes can be enabled or disabled for export from JumpCloud to
 * Google.
 */
export const getDefaultExportAttributes = () => ({
  firstname: Object.freeze({
    key: 'firstname',
    direction: exportAttr,
    attrNames: {
      jc: 'firstname',
      directory: 'name.firstName',
    },
    id: null,
    name: 'First Name',
    value: true,
  }),
  lastname: Object.freeze({
    key: 'lastname',
    direction: exportAttr,
    attrNames: {
      jc: 'lastname',
      directory: 'name.lastName',
    },
    id: null,
    name: 'Last Name',
    value: true,
  }),
  password: Object.freeze({
    key: 'password',
    direction: exportAttr,
    attrNames: {
      jc: 'password',
      directory: 'password',
    },
    id: null,
    name: 'Password',
    value: true,
  }),
  email: Object.freeze({
    key: 'email',
    direction: exportAttr,
    attrNames: {
      jc: 'email',
      directory: 'primaryEmail',
    },
    id: null,
    name: 'Company Email',
    value: true,
  }),
  user_alternate_email: {
    key: 'user_alternate_email',
    direction: excludeAttr,
    attrNames: {
      jc: 'alternate email',
      directory: 'Emails (Other)',
    },
    id: null,
    name: 'Alternate Email',
    value: false,
  },
  user_home_addresses: {
    key: 'user_home_addresses',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses (home)',
      directory: 'addresses (home)',
    },
    id: null,
    name: 'Home Address',
    value: false,
  },
  user_home_phone_numbers: {
    key: 'user_home_phone_numbers',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers (home)',
      directory: 'phones (home)',
    },
    id: null,
    name: 'Home Phone',
    value: false,
  },
  user_mobile_phone_numbers: {
    key: 'user_mobile_phone_numbers',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers (mobile)',
      directory: 'phones (mobile)',
    },
    id: null,
    name: 'Personal Cell',
    value: false,
  },
  user_other_addresses: {
    key: 'user_other_addresses',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses (other)',
      directory: 'addresses (other)',
    },
    id: null,
    name: 'Other Addresses',
    value: false,
  },
  user_other_phone_numbers: {
    key: 'user_other_phone_numbers',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers (other)',
      directory: 'phones (other)',
    },
    id: null,
    name: 'Other Phone Numbers',
    value: false,
  },
  user_primary_organization_cost_center: {
    key: 'user_primary_organization_cost_center',
    direction: excludeAttr,
    attrNames: {
      jc: 'costCenter',
      directory: 'organization.costCenter',
    },
    id: null,
    name: 'Cost Center',
    value: false,
  },
  user_primary_organization_department: {
    key: 'user_primary_organization_department',
    direction: excludeAttr,
    attrNames: {
      jc: 'department',
      directory: 'organization.department',
    },
    id: null,
    name: 'Department',
    value: false,
  },
  user_primary_organization_description: {
    key: 'user_primary_organization_description',
    direction: excludeAttr,
    attrNames: {
      jc: 'employeeType',
      directory: 'organization.description',
    },
    id: null,
    name: 'Employee Type',
    value: false,
  },
  user_primary_organization_employee_id: {
    key: 'user_primary_organization_employee_id',
    direction: excludeAttr,
    attrNames: {
      jc: 'employeeIdentifier',
      directory: 'externalId.value',
    },
    id: null,
    name: 'Employee ID',
    value: false,
  },
  user_primary_organization_title: {
    key: 'user_primary_organization_title',
    direction: excludeAttr,
    attrNames: {
      jc: 'jobTitle',
      directory: 'organization.title',
    },
    id: null,
    name: 'Title',
    value: false,
  },
  user_work_addresses: {
    key: 'user_work_addresses',
    direction: excludeAttr,
    attrNames: {
      jc: 'addresses (work)',
      directory: 'addresses (work)',
    },
    id: null,
    name: 'Work Address',
    value: false,
  },
  user_work_fax_phone_numbers: {
    key: 'user_work_fax_phone_numbers',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers (work_fax)',
      directory: 'phones (work_fax)',
    },
    id: null,
    name: 'Work Fax',
    value: false,
  },
  user_manager: {
    key: 'user_manager',
    direction: excludeAttr,
    attrNames: {
      jc: 'manager',
      directory: 'relations (manager)',
    },
    id: null,
    name: 'Manager',
    value: false,
  },
  user_work_mobile_phone_numbers: {
    key: 'user_work_mobile_phone_numbers',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers (work_mobile)',
      directory: 'phones (work_mobile)',
    },
    id: null,
    name: 'Work Cell',
    value: false,
  },
  user_work_phone_numbers: {
    key: 'user_work_phone_numbers',
    direction: excludeAttr,
    attrNames: {
      jc: 'phoneNumbers (work)',
      directory: 'phones (work)',
    },
    id: null,
    name: 'Work Phone',
    value: false,
  },
});

export const exportAttributesKbUrl = KbArticleUrls.gSuiteAttributes;

export default createDirectoryCollection(
  DirectoryTypeKeys.gSuite,
  getDefaultExportAttributes,
  exportAttributesKbUrl,
);
